import { useCallback } from "react";

import { SaleTypeForPlan } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

import type { FormOptionType } from "@/components/ui/form/_types/type";

type Props = {
	saleTypeForPlan: ForNodeType<SaleTypeForPlan>;
	onSetViewModel: (values: { key: "saleTypeForPlan"; value: ForNodeType<SaleTypeForPlan> }[]) => void;
};

export const useSaleTypeForPlan = ({ saleTypeForPlan, onSetViewModel }: Props) => {
	const saleTypeForPlanOptions = [
		{
			id: "saleTypeForPlan-1",
			label: "常に販売",
			value: SaleTypeForPlan.Ordinary,
		},
		{
			id: "saleTypeForPlan-2",
			label: "特定のプランでのみ販売",
			value: SaleTypeForPlan.Limited,
		},
	] satisfies FormOptionType[];

	const onSetSaleTypeForPlan = useCallback(
		(input: string) => {
			onSetViewModel([
				{ key: "saleTypeForPlan", value: { ...saleTypeForPlan, value: input as SaleTypeForPlan } },
			]);
		},
		[onSetViewModel, saleTypeForPlan],
	);

	return {
		saleTypeForPlan,
		onSetSaleTypeForPlan,
		saleTypeForPlanOptions,
	};
};
